export default {
  SET_D_SUMMARIES: function (state, payloads) {
    state.dSummaries = payloads;
  },
  SET_SALES_BY_SITES: function (state, payloads) {
    state.salesBySites = payloads;
  }
}
